import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import ContactForm from "../contact/contactForm";
import Storage from "../../utils/storage";
import { captchaKey } from "../../config/key";

const ContactSection = () => {
  const lang = Storage.get("lang")?.shortCode
    ? Storage.get("lang")?.shortCode
    : "he";
  return (
    <>
      <GoogleReCaptchaProvider
        language={lang === "en" ? "en" : "iw"}
        // reCaptchaKey="6Ldlc04qAAAAAGtz64kd9mFGaBBovx0VZU01r5Dt" // for testing
        reCaptchaKey={captchaKey} //hidoc key
      >
        <div className="contact-section" id="contact-section">
          <div className="container">
            <div className="new-contact-title">
              <h2>צור קשר איתנו</h2>
              <p>מבטיחים לחזור אליך במהרה</p>
            </div>
            <ContactForm />
          </div>
        </div>
      </GoogleReCaptchaProvider>
    </>
  );
};

export default ContactSection;
